"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reduxObservable = require("redux-observable");

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _actions = require("./actions");

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var fetchSubscriptionDefinitions = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getSubscriptionDefinitions,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.LOAD_SUBSCRIPTION_DEFINITIONS,
  requestStatusSelector: _selectors.getFetchSubscriptionDefinitionsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchSubscriptionDefinitions
}));
var createSubscriptionDefinition = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createSubsciptionDefinition,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_DEFINITION,
  requestStatusSelector: _selectors.getCreateSubscriptionDefinitionRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateSubscriptionDefinition
}));
var createSubscriptionTranslation = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.createSubscriptionTranslation,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.CREATE_SUBSCRIPTION_TRANSLATION,
  requestStatusSelector: _selectors.getCreateSubscriptionTranslationRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.CreateSubscriptionTranslation
}));
var deleteSubscriptionTranslation = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.deleteSubscriptionTranslation,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.DELETE_SUBSCRIPTION_TRANSLATION,
  requestStatusSelector: _selectors.getDeleteSubscriptionTranslationRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.DeleteSubscriptionTranslation
}));
var updateSubscriptionDefinition = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateSubsciptionDefinition,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITION,
  requestStatusSelector: _selectors.getUpdateSubscriptionDefinitionRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateSubscriptionDefinition
}));
var updateSubscriptionDefinitions = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateSubscriptionDefinitions,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_DEFINITIONS,
  requestStatusSelector: _selectors.getUpdateSubscriptionDefinitionsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateSubscriptionDefinitions
}));
var updateSubscriptionPositions = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.updateSubscriptionPositions,
  initiatingActionType: _actions.SubscriptionDefinitionsActionTypes.UPDATE_SUBSCRIPTION_POSITIONS,
  requestStatusSelector: _selectors.getFetchSubscriptionDefinitionsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.UpdateSubscriptionPositions
}));

var _default = (0, _reduxObservable.combineEpics)(fetchSubscriptionDefinitions, createSubscriptionDefinition, createSubscriptionTranslation, deleteSubscriptionTranslation, updateSubscriptionDefinition, updateSubscriptionDefinitions, updateSubscriptionPositions);

exports.default = _default;
module.exports = exports.default;